// item
export default {
  brand_id: null, //externo
  brand_name: null,
  segment_id: null, //externo
  segment_name: null,
  product_id: null, //externo
  product_name: null,
  stock_id: null,
  sell_price: '0.00',
  sell_price_aux: '0.00',
  total_sell_price: '0.00',
  total_units: '0.00',
  total_units_aux: '0.00',
  total_units_delivered: '0.00',
  unit_ship: '0.00',
  unit_ship_aux: '0.00',
  total_ship: '0.00',
  is_delivery: false,
  ref: Math.random()*100
}
